export const SET_COOKIE_CONSENT = 'SET_COOKIE_CONSENT';
export const RESET_COOKIE_CONSENT = 'RESET_COOKIE_CONSENT';
